var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":_vm.onClick}},[_c('a',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('community.removeUserFromCommunity.removeMember'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }